export default "__VITE_ASSET__fe89a60d__"